import { ITrimEditorManagerBase } from '../manager/trim-editor.manager';
import PixelConverter, { WH } from '../../utilities/pixel-converter';

import {
  FillBase,
  ObjectBase,
  PrintBase,
  PrintTrimData,
  RealObjectBounding,
  TempFillBase, TempFillDataEntity, TemplateObjType,
  TempObjectBase,
  TempPrintBase,
  TempTextBase, TempTextDataEntity,
  TempTextStyle,
  TempWindowBase,
  TextBase,
  TrimImageDataEntityInit,
  TrimPrintViewDataEntityInit,
  TrimTempDataEntity,
  VirtualObjectBounding,
  WindowBase,
} from '../model/trim.print-model';
import { TrimTempModel } from '../model/trim.temp-model';
import { ColorCodeConverter } from '../../utilities/colorcode-converter';
import { PrintDataStructure, PrintItemDataEntity } from '../../models/sift/json/print-model';
import { TrimEditableImage } from '../manager/image-edit/trim.editable-image';
import { TrimEditableImageManager } from '../manager/editable-image/trim.editable-image.manager';
import { apiActions } from '../../slices/api-slice';
import {
  ApiPrintShopOrderDataGet,
  PrintShopOrderDataGetResponse,
} from '../../api/sift/front/api-print-meta-shop-order-data';
import { ResponseBase } from '../../api/response-base';
import { printActions } from '../../slices/sift/print-slice';
import { store } from '../../app/store';
import { DateFormatter } from '../../utilities/date-formatter';
import { cloneDeep } from 'lodash';
import { Env } from '../../models/env';
import { ApiGetTemplates } from '../../api/sift/back/api-templates';
import { TemplatesResponse } from '../../models/api/sift/back/api-templates';
import { XmlParser } from '../../manager/xml-parser';
import { TrimDataManager } from '../manager/data/trim-data.manager';


export class TrimPrint {
  // parseData!: any;
  public editableIDList: string[] = [];
  public restoreMount: boolean = false;
  public id: string;
  public editableImgId: string;
  public item: PrintItemDataEntity;
  public base: PrintBase;

  constructor(param: {
    id: string,
    editableImgId: string,
    item: PrintItemDataEntity,
    base: PrintBase
  }) {
    this.id = param.id;
    this.editableImgId = param.editableImgId;
    this.item = param.item;
    this.base = param.base;
  }
}

export class TrimPrintManager implements ITrimEditorManagerBase {

  public kijshopCd: string = '';
  public shopOrderId: string = '';
  public orderId: string = '';
  public editableImageId: string = '';
  public editableImage: TrimEditableImage | null = null;
  public currentPrint: TrimPrint | null = null;
  public printTrimData: PrintTrimData | null = null;
  public structure: PrintDataStructure | null = null;
  public defaultStructure: PrintDataStructure | null = null;
  private _isUpdate: boolean = false;
  private isThumbCreate: boolean = false;

  constructor() {
    // this.container = container;
    // this.commandManager = new TrimCommandManager();
    // this.rulerManager = new TrimRulerManager();
    // this.colorDropper = new TrimColorDropperManager();
    // this.posManager = new TrimPosManager();
    // this.trimmingManager = new TrimTrimmingManager();
    // this.additionalManager = new TrimAdditionalManager();
  }

  initialize() {
  }

  destroy(): void {
  }

  di(): void {
  }

  public async create(param: {
    kijshopCd: string,
    shopOrderId: string,
    orderId: string,
    temp: TrimTempModel,
    editableImgId: string,
    item: PrintItemDataEntity,
    structure?: PrintDataStructure,
    isThumbCreate?: boolean
  }) {
    const { kijshopCd, shopOrderId, orderId, temp, editableImgId, item, structure, isThumbCreate } = param;
    if (this.currentPrint) return;
    this.kijshopCd = kijshopCd;
    this.shopOrderId = shopOrderId;
    this.orderId = orderId;
    this.editableImageId = editableImgId;
    this.structure = structure ?? null;
    this.defaultStructure = cloneDeep(structure) ?? null;
    this.isThumbCreate = !!isThumbCreate;
    const editableImage = TrimEditableImageManager.ins.list.find(v => v.id === editableImgId);
    if (!editableImage) {
      throw new Error('Editable not found !!!!!!!');
    }
    this.editableImage = editableImage;
    // console.log(temp);
    const _temp = this.templateFormatter(temp, item);
    const base = await this.createPrintBase(item, _temp);
    const print = new TrimPrint({
      id: orderId,
      editableImgId,
      item,
      base,
    });
    this.currentPrint = print;
  };

  public delete() {
    this.currentPrint = null;
  };

  static getTrimBaseType = (mode: 1 | 2 | 3) => {
    switch (mode) {
      case 1:
        return 'out';
      case 2:
        return 'in';
      case 3:
        return 'eq';
    }
  }

  private templateFormatter(temp: TrimTempModel, item: PrintItemDataEntity): TempPrintBase {
    const base = temp.layout.print?.[0].base?.[0];
    const frame = base.frame;
    const date = this.getDate(item) ?? '';
    if (!base || !frame?.length) {
      throw new Error('無効なテンプレートです !!!');
    }
    // const template = frame.find(v => v.window[0].object[0].$.id === 'complete_image');
    // const text = frame.find(v => v.window[0].object[0].$.type === 'string');
    const id = this.orderId;

    const tempBase = new TempPrintBase(
      id,
      { width: Number(base?.$.width), height: Number(base?.$.height) },
      [],
    );
    frame.forEach((v, i) => {
      const _window = v.window?.[0];
      const _object = _window?.object?.[0];
      const _fill = _window?.fill?.[0];
      const isText = _object?.$.type === 'string';
      const textVal = _object?.string?.[0].text?.[0].trim() ? _object?.string?.[0].text?.[0] : date;
      const objType: TemplateObjType = (() => {
        if (isText) {
          return _object?.string?.[0].text?.[0].trim() ? 'tempText' : 'dateText';
        }
        return 'template';
      })()

      const text = isText ? new TempTextBase(
        textVal,
        Number(_object?.string?.[0].$.point ?? '90'),
        _object?.string?.[0].$.face ?? '',
        Number(_object?.antialias?.[0].$.enable ?? '1'),
        new TempTextStyle(
          {
            width: Number(_object?.edge?.[0].$.width ?? '0.3'),
            color: ColorCodeConverter.Hex2Color(_object?.edge?.[0].$.color ?? '0xffffff') ?? '#ffffff',
          },
          '#000000',
          false,
          false,
        ),
      ) : undefined;
      const object = _object ? new TempObjectBase(
        objType,
        _object?.$.id,
        _object?.$.type,
        text,
      ) : undefined;
      const fill = _fill ? new TempFillBase(
        Number(_fill.$.enable),
        ColorCodeConverter.Hex2Color(_fill.$.color ?? '0xffffff') ?? '#ffffff',
      ) : undefined;
      const window = new TempWindowBase(
        id,
        i + 1,
        {
          wh: { width: Number(_window?.$.width), height: Number(_window?.$.height) },
          pos: { x: Number(_window?.$.x), y: Number(_window?.$.y) },
        },
        _window?.$.attribute ?? '24',
        object,
        fill,
      );
      tempBase.addWindow(window);
    });

    return tempBase;
  }

  private async getPrintTrimData(item: PrintItemDataEntity, temp: TempPrintBase, isRotate?: boolean): Promise<void> {
    if (!this.editableImage) return;
    // const recordImageData = new TrimImageData(this.editableImage.id,);

    const printTrimData = await this.createPrintTrimData({ item, temp, isRotate })
    this.printTrimData = cloneDeep(printTrimData);
  }

  private async createPrintBase(item: PrintItemDataEntity, temp: TempPrintBase, isRotate?: boolean): Promise<PrintBase> {

    const id = this.orderId;
    // const printTrimData = this.printTrimData ? this.printTrimData : await this.getPrintTrimData(item, temp);
    if (!this.printTrimData) {
      await this.getPrintTrimData(item, temp, isRotate);
    }
    const date = this.getDate(item) ?? '';
    const printBase = new PrintBase(
      id,
      { width: temp.wh.width, height: temp.wh.height },
      [],
    );
    temp.window.forEach((v, i) => {
      if (!this.editableImage) return;
      if (v.object) {
        switch (v.object?.objType) {
          case 'template':
            // const template = temp.getTempWindow();
            // if (!template) break;
            const { wh, pos } = v.bound;
            TrimDataManager.setAdditionalValue = wh.width <= wh.height ? wh.width : wh.height;
            // const image = printTrimData?.image;
            // console.log(image);
            printBase.addWindow(new WindowBase(
              this.editableImage.id,
              v.depth,
              new RealObjectBounding({ width: wh.width, height: wh.height }, { x: pos.x, y: pos.y }),
              new VirtualObjectBounding({
                width: wh.width,
                height: wh.height,
              }, { x: pos.x, y: pos.y }),
              new ObjectBase(
                this.editableImage.id,
                {
                  pos: { x: 0, y: 0 },
                  wh: { width:  0, height: 0 },
                },
                0,
                'image',
                v.object?.type,
              ),
            ));
            break;
          case 'dateText':
            // const text = temp.getTextWindow();
            // console.warn(text);
            // if (!text) break;
            printBase.addWindow(new WindowBase(
              this.editableImage.id,
              v.depth,
              new RealObjectBounding({ width: v.bound.wh.width, height: v.bound.wh.height }, {
                x: v.bound.pos.x,
                y: v.bound.pos.y,
              }),
              new VirtualObjectBounding({
                width: v.bound.wh.width,
                height: v.bound.wh.height,
              }, { x: v.bound.pos.x, y: v.bound.pos.y }),
              new ObjectBase(
                this.editableImage.id,
                { pos: { x: 0, y: 0 }, wh: { width: 0, height: 0 } },
                0,
                'dateText',
                v.object?.type,
                new TextBase(
                  this.editableImage.id,
                  v.object.text?.value ?? '',
                  Number(v.object?.text?.point ?? '90'),
                  (v.object?.text?.font ?? 'ＭＳ Ｐゴシック'),
                  (v.object?.text?.style ?? new TempTextStyle()),
                ),
              ),
            ));
            break
            case 'tempText':
            // const text = temp.getTextWindow();
            // console.warn(text);
            // if (!text) break;
            printBase.addWindow(new WindowBase(
              this.editableImage.id,
              v.depth,
              new RealObjectBounding({ width: v.bound.wh.width, height: v.bound.wh.height }, {
                x: v.bound.pos.x,
                y: v.bound.pos.y,
              }),
              new VirtualObjectBounding({
                width: v.bound.wh.width,
                height: v.bound.wh.height,
              }, { x: v.bound.pos.x, y: v.bound.pos.y }),
              new ObjectBase(
                this.editableImage.id,
                { pos: { x: 0, y: 0 }, wh: { width: 0, height: 0 } },
                0,
                'tempText',
                v.object?.type,
                new TextBase(
                  this.editableImage.id,
                  v.object.text?.value ?? '',
                  Number(v.object?.text?.point ?? '90'),
                  (v.object?.text?.font ?? 'ＭＳ Ｐゴシック'),
                  (v.object?.text?.style ?? new TempTextStyle()),
                ),
              ),
            ));
        }
      } else if (v.fill) {
        const { wh, pos } = v.bound;

        printBase.addWindow(new WindowBase(
          this.editableImage.id,
          v.depth,
          new RealObjectBounding({ width: wh.width, height: wh.height }, { x: pos.x, y: pos.y }),
          new VirtualObjectBounding({
            width: wh.width,
            height: wh.height,
          }, { x: pos.x, y: pos.y }),
          undefined,
          new FillBase(
            (v.fill.enable ?? 1),
            ColorCodeConverter.Hex2Color(v.fill.color) ?? '#FFFFFF',
          ),
        ));
      }

    });
    return printBase;
  }

  getEdge(frameSize: WH, fills: WindowBase[]) {
    return fills.find((window) => {
      const { pos, wh } = window.virtual;
      if (pos.x || pos.y) {
        return false;
      }
      return wh.width > frameSize.width && wh.height > frameSize.height;
    });
  }

  private async createPrintTrimData(
    args: { item: PrintItemDataEntity, temp: TempPrintBase, isRotate?: boolean },
  ): Promise<PrintTrimData> {
    return new Promise((resolve, reject) => {
      const { item, temp, isRotate } = args;
      const date = this.getDate(item) ?? '';
      const id = `${this.orderId}_${this.editableImageId}`;
      const dateText = temp.getDateTextWindow();
      const tempTexts = temp.getTextWindow();
      const tempFrame = temp.getTempWindow();
      const fills = temp.getFillWindow();

      const tmpData = new TrimTempDataEntity(
        { width: temp.wh.width, height: temp.wh.height },
        dateText ? {
          depth: dateText.depth,
          x: dateText.bound.pos.x,
          y: dateText.bound.pos.y,
          width: dateText.bound.wh.width,
          height: dateText.bound.wh.height,
          attribute: dateText.attribute,
          edge: {
            color: ColorCodeConverter.Color2Hex(dateText.object?.text?.style.outline.color ?? '#ffffff'),
            width: dateText.object?.text?.style.outline.width ?? 0.3,
          },
          antialiasEnable: dateText.object?.text?.antialiasEnable ?? 1,
          style: { face: dateText.object?.text?.font ?? 'ＭＳ ゴシック', point: dateText.object?.text?.point ?? 90 },
          value: dateText.object?.text?.value ?? '',
        } : undefined,
      );
      tmpData.setTempTexts(tempTexts.map((data): TempTextDataEntity => {
        return {
          depth: data.depth,
          x: data.bound.pos.x,
          y: data.bound.pos.y,
          width: data.bound.wh.width,
          height: data.bound.wh.height,
          attribute: data.attribute,
          edge: {
            color: ColorCodeConverter.Color2Hex(data.object?.text?.style.outline.color ?? '#ffffff'),
            width: data.object?.text?.style.outline.width ?? 0.3,
          },
          antialiasEnable: data.object?.text?.antialiasEnable ?? 1,
          style: { face: data.object?.text?.font ?? 'ＭＳ ゴシック', point: data.object?.text?.point ?? 90 },
          value: data.object?.text?.value ?? '',
        }
      }));
      tmpData.setFills(fills.map((data): TempFillDataEntity => {
        return {
          depth: data.depth,
          x: data.bound.pos.x,
          y: data.bound.pos.y,
          width: data.bound.wh.width,
          height: data.bound.wh.height,
          attribute: data.attribute,
          enable: data.fill?.enable ?? 0,
          color: ColorCodeConverter.Color2Hex(data.fill?.color ?? '#ffffff'),
        }
      }));

      const getDefaultResult = (id: string) => {
        return new PrintTrimData(
          id,
          {
            id,
            itemId: item.id,
            config: {space: item.productData?.meta?.layoutMargin ? 1 : 0, trimBaseType: item.productData?.meta?.trimBaseType ?? 1},
            temp: tmpData,
            image: new TrimImageDataEntityInit(this.editableImageId, tempFrame?.depth ?? 0, tempFrame ? new RealObjectBounding(tempFrame?.bound.wh, tempFrame?.bound.pos) : undefined),
            texts: [],
            stamps: [],
            view: new TrimPrintViewDataEntityInit(),
          }
        );
      }

      const onError = () => {
        const result = getDefaultResult(id);
        this._isUpdate = false;
        resolve(result);
      };
      if (this.isThumbCreate) {
        onError();
        return;
      }
      store.dispatch(apiActions.run(
        new ApiPrintShopOrderDataGet({
          kijshopCd: this.kijshopCd,
          shopOrderId: this.shopOrderId,
        }),
        {
          onSuccess: (res: ResponseBase<PrintShopOrderDataGetResponse>) => {
            if (!res.body.data || (Number(res.error?.errorCode) !== 200)) {
              onError();
            } else {
              const target = res.body.data.jsonList.find((v) => v.filename.includes(id));
              if (!target) {
                onError();
              } else {
                try {
                  const data = JSON.parse(target.body);
                  const result = isRotate ? getDefaultResult(target.filename) : new PrintTrimData(`${target.filename}`, data);
                  this._isUpdate = true;
                  resolve(result);
                } catch (e) {
                  onError();
                }
              }
            }
          },
        },
      ));
    });
  }

  private getDate(item: PrintItemDataEntity) {
    const image = item.images.find(v => v.id === this.editableImageId);
    // const isDate = image?.datePrint;
    // if (!isDate) return null;
    const date = this.editableImage?.exif.createDate;
    if (!date) return null;
    return DateFormatter.date2str(date);
  }

  get isUpdate() {
    return this._isUpdate;
  }

  async rotateTemp() {
    const item = this.structure?.item?.[this.orderId];
    if (!item) throw new Error('not found itemModel !!!');
    const temp = await this.loadTemplate(item);
    if (!temp) throw new Error('not found tempModel !!!');
    const _temp = this.templateFormatter(temp, item);
    this.printTrimData?.changeTemp(_temp);
    if (!this.currentPrint || !this.printTrimData) throw new Error('not found printModel !!!');
    this.printTrimData = null;
    this.currentPrint.base = await this.createPrintBase(item, _temp, true);
  }

  private loadTemplate = (item: PrintItemDataEntity) => new Promise<TrimTempModel | null>((resolve) => {
    const itemId = item.productData?.ProductDetailItemData?.itemId ?? '';
    const edgeDtempId = item.productData?.meta?.borderType;
    const image = item.images.find(v => v.id === this.editableImageId);
    if (!image) {
      resolve(null);
      return;
    }
    image.rotate = image.rotate === '0' ? '1' : '0';
    const nextRotate = !Number(image.rotate) ? '1' : '2';
    const printDateFlg = image.datePrint;
    const template = this.structure?.getTemplate(item.id, nextRotate, printDateFlg);
    if (template) {
      resolve(template.template);
    } else {
      resolve(null);
    }
    // image.rotate = image.rotate === '0' ? '1' : '0';
    // const BASE_URL = `${Env.api.back.protocol}://${Env.api.back.host}/templates`;
    //
    // store.dispatch(apiActions.run(new ApiGetTemplates({itemId, edgeDtempId, directFlg: Number(nextRotate)}), {
    //   onSuccess: (res) => {
    //     const data = res.body.data as TemplatesResponse;
    //     const target = data.templateGroupData.find((v) => v.directFlg === nextRotate);
    //     if (!target) {
    //       console.error('template not found !!!!');
    //       resolve(null)
    //       return;
    //     };
    //     console.log(BASE_URL);
    //     return fetch(
    //       `${BASE_URL}/${target.hpsTppath}/template.xml`,
    //       { method: 'GET', mode: 'cors' },
    //     ).then(res => res.text())
    //       .then(async (body) => {
    //         console.log(body);
    //         const temp = await new XmlParser().parse<TrimTempModel>(body);
    //         resolve(temp)
    //       });
    //   },
    //   onError(e) {
    //     console.error('error-', e);
    //   }
    // }))
  });
}
